import React, { useContext } from "react";
import styles from "./Images2.module.scss";
import { Context } from "../../Store";
import { motion } from "framer-motion";

const Images2 = (props) => {
  let { dir, variants1 } = useContext(Context);
  const { experiencesRes, start } = props;
  const { subTitle, desc, images } = experiencesRes[start];

  return (
    <motion.section
      variants={variants1}
      initial="hidden"
      animate="showComponets"
      id={styles.startSell}
    >
      <div className={styles.container}>
        <div className={styles.item0}>
          <h3>{subTitle}</h3>
          <p>{desc}</p>
        </div>
        <div className={styles.item1}>
          <img
            className={dir === "ltr" ? styles.startSell0l : styles.startSell0r}
            src={images[0]?.image}
            alt=""
          />
          <img
            className={dir === "ltr" ? styles.startSell1l : styles.startSell1r}
            src={images[1]?.image}
            alt=""
          />
        </div>
      </div>
    </motion.section>
  );
};

export default Images2;
